// import APIs
import { getRosterDutyHourTypes } from 'RestAPIs/roster/duty-hour-types';

// import external libraries
import { useQuery } from 'react-query';

// import types
import { GetRosterDutyHourTypesOptions } from './useGetDutyHourTypes.types';

const useGetDutyHourTypes = (
  { startDate, endDate }: GetRosterDutyHourTypesOptions,
  options: Record<string, any> = {},
  queryKeyPrefix = 'dutyHourTypes'
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    [queryKeyPrefix, startDate, endDate],
    async () => {
      const { data } = await getRosterDutyHourTypes({
        startDate,
        endDate
      });
      return data;
    },
    options
  );
  return { data, isFetching, isError, refetch };
};

export default useGetDutyHourTypes;
